module.exports = __webpack_public_path__ + "static/img/083_TO8_1731_og.b7a8e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/083_TO8_1731_og.jpg
// module id = PD88
// module chunks = 0